/**
 * Strips all non-digits out of a string
 *
 * @todo consider merging with stripNonNumeric.ts
 *
 * @param {value} a string with mixed characters
 * @return {string} the value with only the digits
 */
export const numbersOnly = (value: string): string => {
  return value.replace(/[^\d]/g, "");
};

/**
 * Strips all non-digits out of a string, but allows for a decimal point
 *
 * @param {value} a string with mixed characters
 * @return {string} the value with only the digits or decimal points
 */
export const validCurrencyInputsOnly = (value: string): string =>
  value?.replace(/\$/g, "").replace(/,/g, "");

/**
 * Pads a digit with trailing zeroes as needed
 *
 * @param {value} a number as a string
 * @return {string} the value with trailing zeroes added (if necessary)
 */
export const decimalToFivePlaces = (d: string): string => Number(d).toFixed(5);
export const decimalToThreePlaces = (d: string): string => Number(d).toFixed(3);
